import {Component,OnInit} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {Prestation,TypePrestation,TypeRemboursement} from "@domain/prestation/prestation";
import {Router} from "@angular/router";
import {PrestationService} from "@services/admin/frais/prestation.service";
import {TypeBareme} from "@domain/prestation/TypeBareme";

/**
 * Composant d'un item de la liste des prestations
 */
@Component({
	host: {'data-test-id': 'prestation-admin-list-item'},
	templateUrl: './prestation-admin-list-item.component.html'
})
export class PrestationAdminListItemComponent extends ListViewItem<Prestation> implements OnInit {
	/* Déclaration pour accès dans le template */
	protected readonly TypeRemboursement = TypeRemboursement;
	protected readonly TypeBareme = TypeBareme;

	/** Type de la prestation */
	protected typePrestation: {type: TypePrestation,libelle: string};

	/** Barème de la prestation */
	protected typeBareme: {id: TypeBareme,libelle: string};

	/**
	 * Constructeur
	 */
	constructor(private router: Router,private prestationService: PrestationService) {
		super();
	}

	/**
	 * Initialisation du composant
	 */
	ngOnInit() {
		//Récupération du type de prestation associé
		this.typePrestation = this.prestationService.listeTypes.find(tp => tp.type == this.data.type);

		//Récupération du barème associé
		this.typeBareme = this.prestationService.listeBaremes.find(tb => tb.id == this.data.typeBareme);
	}

	/**
	 * Méthode appelée lors de la sélection d'une prestation
	 */
	onSelect() {
		//Navigation vers la page de détail d'une prestation
		this.router.navigate(['Admin/Frais/Prestation/' + this.data.idPrestation]);
	}
}
